import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class Templates extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({
                hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
                hideMultipleDeletePopup: false
            });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchTemplateDataApi()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchTemplateDataApi()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];
        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteTemplateApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchTemplateDataApi()
                this.setState({ disabled: false })

            }
        }];

        this.multipleDeleteButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteMultipleTemplateApi()
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideMultipleDeletePopup: false,
                });
            }
        }];

        this.previousRow = null;
        this.state = {
            disabled: false,
            pageNum: null,
            data: [
                {
                    id: '',
                    templateString: '',
                    autoTranslate: '',
                    deleteRow: false
                }
            ],
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            selected: null,
            checkBoxRows: [],
            selectedRows: [],
            disableMultipleDelete: true,
            hideMultipleDeletePopup: false

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {

        localStorage.setItem("stateSlotId", this.props.location.state.stateSlotId);
        setTimeout(() => {
            this.fetchLanguageApi();
            this.fetchTemplateDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.props.history.push("/projectmgmt/nlutab")
        });

    }


    saveTemplateApi = (props, e) => {
        var addTemplateController = this
        props.original.templateString =
            document.getElementById("templateString" + props.index).innerText.trim();
        props.original.autoTranslate =
            document.getElementById("autoTranslate" + props.index).checked;

        addTemplateController.state.editedId = "-1";
        addTemplateController.setState(this.state);

        var validateResult = this.validateCells(
            props.original.templateString, props.original.autoTranslate);

        if (validateResult == true) {

            var addedData = {
                templateString: props.original.templateString,
                autoTranslate: props.original.autoTranslate,
                stateSlotId: localStorage.getItem('stateSlotId'),
                projectId: localStorage.getItem('currentProjectId'),
                language: document.getElementById('languageIdDropDown').value
            };


            $.ajax({
                url: "/api/templates",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {

                        addTemplateController.notifyAdd();
                        addTemplateController.fetchTemplateDataApi();
                        addTemplateController.state.disabled = false
                    } else {
                        addTemplateController.notifyError(res.result);
                    }
                },

                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })

        }
    }

    notifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Template Added Successfully</b>, {
            position: "top-center",

        });

    }
    notifyError(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{
            paddingRight: '0px',
            height: '20px', width: '20px'
        }} content="" />{response}</b>, {
            position: "top-center"
        });
    }

    updateTemplateApi(props, e) {


        props.original.templateString = document.getElementById("templateString" + props.index).innerText.trim();
        props.original.autoTranslate = document.getElementById("autoTranslate" + props.index).checked;

        var validateResult = this.validateCells(props.original.template,
            props.original.autoTranslate);
        if (validateResult == true) {

            var updatedData = {
                id: props.original.id,
                templateString: props.original.templateString,
                autoTranslate: props.original.autoTranslate,
                stateSlotId: localStorage.getItem('stateSlotId'),
                language: document.getElementById('languageIdDropDown').value,
                projectId: localStorage.getItem('currentProjectId')

            };
            var updatedDataController = this;
            $.ajax({
                url: "/api/templates",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchTemplateDataApi();

                    } else {
                        updatedDataController.notifyFailedUpdate();
                    }
                },

                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }
    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Template Updated Successfully</b>, {
            position: "top-center",

        });
    }
    deleteTemplateApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;


        $.ajax({
            url: "/api/templates/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {
                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteApiViewController.notifyDelete();

                    deleteRowViewController.splice(id, 1);

                } else {
                    deleteApiViewController.notifyFailedDelete();
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
        deleteApiViewController.fetchTemplateDataApi();
    }

    deleteMultipleTemplateApi = () => {
        let deleteApiViewController = this;
        var idListVal = deleteApiViewController.state.selectedRows;
        var idList = [];
        for (var i = 0; i < idListVal.length; i++) {
            idList.push(idListVal[i].id);
        }

        $.ajax({
            url: "/api/templates-delete-multiple/" + idList,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {

                if (res.success === true) {
                    deleteApiViewController.state.hideMultipleDeletePopup = false;
                    deleteApiViewController.state.disableMultipleDelete = true;
                    deleteApiViewController.state.checkBoxRows = [];
                    deleteApiViewController.setState(deleteApiViewController.state);
                    deleteApiViewController.fetchTemplateDataApi();
                    deleteApiViewController.notifyMultipleDeleteSuccess();
                } else {
                    deleteApiViewController.notifyFailedDelete();
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }


    notifyDelete() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;Template Deleted Successfully</b>, {
            position: "top-center",
        });

    }

    notifyMultipleDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;Selected Templates Deleted Successfully</b>, {
            position: "top-center",
        });

    }

    fetchTemplateDataApi = () => {
        var fetchController = this;
        $.ajax({
            url: "/api/templates",
            async: false,
            method: 'GET',
            data: {
                stateSlotId: localStorage.getItem('stateSlotId'),
                language: document.getElementById('languageIdDropDown').value

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    fetchController.setState({
                        data: messages,
                        successResp: true
                    })

                } else {
                    fetchController.setState({

                        successResp: false
                    })

                    fetchController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }

    fetchLanguageApi() {
        var languageController = this;
        $.ajax(
            {
                url: "/api/project-languages-selected",
                async: false,
                method: 'GET',
                data: {
                    projectId: localStorage.getItem("currentProjectId"),
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        var language = res.result;
                        languageController.setState({ language: language });
                        var numberOfLanguages = language.length;
                        var ele3 = document.getElementById("languageIdDropDown");
                        if (ele3 != null) {
                            ele3.innerHTML = null;
                            for (var i = 0; i < numberOfLanguages; i++) {
                                ele3.innerHTML = ele3.innerHTML + '<option value="' + language[i]['code'] + '">' + language[i]['code'] + '</option>';
                            }
                        }
                    }


                    else {
                        languageController.notifyError(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }


            }
        )


    }



    addRow = (data) => {
        var rowController = this;
        if (rowController.state.pageNum != 0) {
            rowController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({

            templateString: '',
            autoTranslate: '',

        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }
    validateCells(template, autoTranslate) {
        if ((template == "" || autoTranslate == null)) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }
    }
    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please fill the fields</b>, {
            position: "top-center"
        });

    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {

        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }


    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.state.selectedRows = [];
        this.state.disableMultipleDelete = true;
        this.state.checkBoxRows = [];
        this.fetchTemplateDataApi()
        this.setState({ disabled: false })
    }

    langhandleChange = (e) => {
        this.setState({ languageValue: e.target.value })
        this.fetchTemplateDataApi()
    }
    goBack = () => {

        this.props.history.push({
            pathname: '/projectmgmt/slu-slot-details',
            state: {
                intentId: localStorage.getItem("intentId"),
                intentName: localStorage.getItem("current-slot-name"),
                pageNum: this.props.location.state.pageNum
            }

        });
        this.setState(this.state)
    }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    selectedRow = (props, e) => {
        this.state.selectedRows = [];
        var jsonData = props.original;
        for (var i = 0; i < this.state.checkBoxRows.length; i++) {
            if (this.state.checkBoxRows[i]["id"] == jsonData.id) {
                this.state.checkBoxRows.splice(i, 1);
            }
        }
        if (e.target.checked) {
            jsonData["selected"] = true;
        } else {
            jsonData["selected"] = false;
        }
        this.state.checkBoxRows.push(jsonData);
        for (var i = 0; i < this.state.checkBoxRows.length; i++) {
            if (this.state.checkBoxRows[i]["selected"] == true) {
                this.state.selectedRows.push(this.state.checkBoxRows[i]);
            }
        }
        if (this.state.selectedRows.length > 0) {
            this.state.disableMultipleDelete = false;
        } else {
            this.state.disableMultipleDelete = true;
        }
        this.setState(this.state);
    }

    render() {

        const { data } = this.state
        const columns = [
            {
                Header: <b>Select</b>,
                accessor: "id",
                sortable: false,
                width: 55,
                Cell: props => (
                    <div style={{ textAlign: 'center' }}>
                        <input type="checkbox"
                            disabled={props.original.id === undefined ? true : false}
                            style={{ width: "20px", height: "20px", cursor: "pointer" }}
                            onClick={(e) => {
                                this.selectedRow(props, e)
                            }}
                            checked={props.original.selected}
                        />
                    </div>)
            },
            {
                Header: <b>Template</b>,
                accessor: 'templateString',
                sortable: false,

                Cell: props =>
                (<div
                    Align="left" className="input"
                    style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                            '1px solid #D2D4DC' : 'none', borderRadius:
                            (props.original.id == undefined || props.original.id == this.state.editedId) ? '2px' : 'none', paddingLeft: '2px'
                    }}
                    suppressContentEditableWarning
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}


                    type="text" id={"templateString" + props.index} value={props.original.id == undefined ? "" :
                        props.original.templateString} >{props.original.templateString}</div>)
            },


            {
                Header: <b>Auto Translate</b>,
                accessor: 'autoTranslate',
                width: 200,
                sortable: false,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"autoTranslate" + props.index}
                                    defaultChecked={props.original.autoTranslate}
                                    disabled={(props.original.id == null) ? false :
                                        props.original.id != this.state.editedId}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },


            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">
                        {/* edit and delete button */}
                        <div style={{ marginTop: '-9px' }}>
                            <p>
                                <button style={{ backgroundColor: "transparent", border: "none" }}>
                                    <img className="img-responsive"
                                        style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                        title={(props.original.id == undefined) ||
                                            (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                        src={(props.original.id == null) ?
                                            this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                                this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == null) ?
                                                this.saveTemplateApi(props, e) :
                                                (props.original.id == this.state.editedId) ?
                                                    this.updateTemplateApi(props, e) :
                                                    this.makeCelleditable(props, e);
                                        }}
                                    /></button>
                                <button style={{ backgroundColor: "transparent", border: "none" }}>
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                        title="Delete"
                                        onClick={() => {
                                            (props.original.id) === undefined ?
                                                this.fetchTemplateDataApi() :
                                                this.setState({
                                                    hideDeletePopup: true, deletePropIndex: props.index,
                                                    propsId: props.original.id
                                                })
                                        }}
                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>


                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />


                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-3" style={{ marginTop: '16px' }}>
                                <img src="assets/images/arrow.svg" title="Go Back"
                                    onClick={this.goBack}
                                    style={{ width: '24px', cursor: 'pointer' }} />
                            </div>
                            <div className="col-sm-4" Align='right'>
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Utterance Templates for the slot {this.props.location.state.slotName} of {localStorage.getItem("current-slot-name")} intent</h6>
                            </div>

                            <div className="col-sm-3" Align='right'>

                                <select className="input-group mb-3 form-control select2 " style={{ width: '60%', marginTop: '6px' }}
                                    tabIndex={-1} aria-hidden="true"
                                    name="languageIdDropDown" id="languageIdDropDown"
                                    placeholder="Select language"

                                    onChange={this.langhandleChange}>

                                </select>
                            </div>
                            {/* Add button */}
                            <div className="col-sm-2" Align='right'>
                                <button className="btn action-button "
                                    disabled={this.state.disableMultipleDelete}
                                    title="Delete Selected"
                                    id="deleteMultiple"
                                    onClick={() => {
                                        this.setState({
                                            hideMultipleDeletePopup: true
                                        })
                                    }
                                    }>
                                    <img src={"./assets/images/baseline_delete_white_24dp.png"} />
                                </button>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button"
                                    title="Refresh">

                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">

                                        <ReactTable
                                            getTrProps={(state, rowInfo) => {
                                                if (rowInfo) {
                                                    return {
                                                        style: {
                                                            background: this.state.selectedRows.some((selectedRow) => selectedRow.id == rowInfo.original.id) ? '#E6E6D8' : 'white'
                                                        }
                                                    }
                                                } else {
                                                    return {}
                                                }
                                            }
                                            }
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}

                                        />
                                    </div>
                                    <ToastContainer className="Toast-at-center" />

                                    {/*Dialog Component For Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Template' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog}
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete the Template?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                                    </DialogComponent>

                                    {/*Dialog Component For Multiple Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Template' showCloseIcon={true} buttons={this.multipleDeleteButton}
                                        ref={dialog => this.dialogInstance = dialog}
                                        visible={this.state.hideMultipleDeletePopup} close={this.dialogClose}>
                                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete the selected templates?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                                    </DialogComponent>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default Templates;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/intent/Templates.js